import React, { useEffect, useRef } from "react";

const GOOGLE_AD_CLIENT = "ca-pub-4049765723358227";

const GoogleAd = ({
  slot,
  client = GOOGLE_AD_CLIENT,
  format = "auto",
  responsive = "true",
  style = { display: "block" },
  className = "my-4 flex justify-center items-center overflow-hidden",
}) => {
  const adRef = useRef(null);
  const isLoaded = useRef(false);

  useEffect(() => {
    // Avoid double-pushing if React re-renders or in StrictMode
    if (isLoaded.current) return;

    try {
      if (typeof window !== "undefined" && adRef.current) {
        // If the element does not already have an ad rendered
        if (!adRef.current.getAttribute("data-ad-status")) {
          (window.adsbygoogle = window.adsbygoogle || []).push({});
          isLoaded.current = true;
        }
      }
    } catch (error) {
      // Ignore adsbygoogle duplicate push errors or ad blocker errors silently
      if (process.env.NODE_ENV === "development") {
        console.warn("AdSense push warning:", error);
      }
    }
  }, []);

  const isLocalhost =
    typeof window !== "undefined" &&
    (window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1" ||
      window.location.hostname.startsWith("172."));

  return (
    <div className={`google-ad-wrapper ${className}`}>
      {isLocalhost && !slot && (
        <div
          style={{
            padding: "8px 16px",
            background: "#f8f9fa",
            border: "1px dashed #cbd5e1",
            borderRadius: "6px",
            fontSize: "12px",
            color: "#64748b",
            textAlign: "center",
            width: "100%",
            maxWidth: "728px",
          }}
        >
          <span>Google AdSense Slot ({client})</span>
          <span style={{ display: "block", fontSize: "11px", color: "#94a3b8" }}>
            (Live ads only display on approved production domains, not localhost)
          </span>
        </div>
      )}
      <ins
        ref={adRef}
        className="adsbygoogle"
        style={style}
        data-ad-client={client}
        {...(slot ? { "data-ad-slot": slot } : {})}
        data-ad-format={format}
        data-full-width-responsive={responsive}
      />
    </div>
  );
};

export default GoogleAd;
